"use client";

import { useState } from "react";
import Comment from "@/components/Comment"; // Yorum bileşenini içe aktarıyoruz
import Pagination from "@/components/Pagination"; // Sayfalama bileşenini içe aktarıyoruz

export default function CommentSection({ kod, comments: initialComments }) {
  const [comments, setComments] = useState(initialComments || []); // Gelen yorumlar state'e alınıyor
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const commentsPerPage = 10;

  // Sayfalama için yorumları bölme
  const indexOfLastComment = currentPage * commentsPerPage;
  const indexOfFirstComment = indexOfLastComment - commentsPerPage;
  const currentComments = comments.length
    ? comments.slice(indexOfFirstComment, indexOfLastComment)
    : []; // comments varsa slice işlemi yapılır

  const totalPages = Math.ceil(comments.length / commentsPerPage);

  // Yorum gönderme işlemi
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`/.netlify/functions/comments?kod=${kod}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, comment, kod }), // Kod parametresi de gönderiliyor
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message);
      }

      const newComment = await res.json();
      setComments((prev) => [newComment.data, ...prev]); // Yeni yorum listeye ekleniyor
      setName("");
      setComment("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="comment-section">
      {/* Yorum Gönderme Formu */}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Adınız"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <textarea
          placeholder={`${kod} hisse hakkında düşüncelerinizi yazın`}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          required
        ></textarea>
        <button type="submit" disabled={loading}>
          {loading ? "Gönderiliyor..." : "Gönder"}
        </button>
      </form>

      {/* Yorumlar */}
      <h3>Yorumlar</h3>
      {loading && <p>Yorumlar yükleniyor...</p>}
      {error && <p>Hata: {error}</p>}
      {!loading && comments.length === 0 && <p>Yorum bulunmamaktadır.</p>}

      {currentComments
        .filter((comment) => comment.hidden !== true) // "hidden: true" olan yorumları hariç tutuyoruz
        .slice() // Yorum listesinin kopyasını oluşturuyoruz (orijinal listeyi bozmamak için)
        .map((comment, index) => {
          // Yorum tarihi $date formatında ise doğru formatta okumak için kontrol
          const formattedDate = comment.date?.$date
            ? new Date(comment.date.$date)
            : new Date(comment.date);

          return (
            <Comment
              key={index}
              name={comment.name} // Yorum yapan kişinin adı
              date={formattedDate} // Formatlanmış tarih
              content={comment.comment} // Yorum içeriği
            />
          );
        })}

      {/* Sayfalama Bileşeni */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
}
